import {
    Beer,
    Wine,
    Coffee,
    GraduationCap,
    Dumbbell,
    Plane,
    Tent,
    Trees,
    Trophy,
    Hotel,
    Home,
    BedDouble,
} from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const PLACES = [
    { icon: GraduationCap, label: "University" },
    { icon: Wine, label: "Bar" },
    { icon: Home, label: "Residential communities" },
    { icon: Coffee, label: "Coffee shop" },
    { icon: Dumbbell, label: "Gym" },
    { icon: Plane, label: "Airport" },
    { icon: Tent, label: "Festival" },
    { icon: BedDouble, label: "Student accommodation" },
    { icon: Trees, label: "Park" },
    { icon: Trophy, label: "Sports club" },
    { icon: Hotel, label: "Hotel" },
    { icon: Beer, label: "Pub" },
];

export const WhereToUse = () => {
    return (
        <section className="mx-auto max-w-6xl px-6 py-24 sm:py-32" data-testid="where-to-use-section">
            <Reveal className="max-w-2xl">
                <Chapter index="04" label="Places" />
                <h2
                    data-testid="where-to-use-heading"
                    className="font-display mt-5 text-4xl font-medium leading-[1.1] tracking-tight text-[#1D201A] sm:text-5xl"
                >
                    Wherever Life happens.
                </h2>
                <p className="mt-5 text-base leading-relaxed text-[#5C5F58] sm:text-lg">
                    Lunar is made for the places where life already happens.
                </p>
            </Reveal>

            <Reveal delay={0.1}>
                <div
                    data-testid="where-to-use-places-grid"
                    className="mt-14 grid grid-cols-2 gap-3 sm:grid-cols-5"
                >
                    {PLACES.map(({ icon: Icon, label }) => (
                        <div
                            key={label}
                            data-testid={`where-to-use-place-chip-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                            className="group flex flex-col items-start gap-5 rounded-2xl border border-[#E5E3DC] bg-[#F9F8F4] p-5 transition-colors duration-300 hover:border-[#899B6A]"
                        >
                            <Icon
                                className="h-6 w-6 text-[#4A5D23] transition-colors duration-300 group-hover:text-[#2C3618]"
                                strokeWidth={1.5}
                            />
                            <span className="text-sm font-medium text-[#3E413B]">{label}</span>
                        </div>
                    ))}
                </div>
            </Reveal>

            <Reveal delay={0.15} className="mt-16 max-w-xl">
                <p className="font-display text-2xl font-medium italic text-[#4A5D23] sm:text-3xl">
                    Want Lunar where you are? 🌿
                </p>
                <p className="mt-4 text-base leading-relaxed text-[#3E413B]">
                    Vote for your town, city or favourite venue and help decide where Lunar goes next.
                </p>
                <p className="mt-2 text-sm text-[#5C5F58]">
                    The places with the most demand will be next to go live.
                </p>
                <a
                    href="/download"
                    data-testid="vote-download-note"
                    className="mt-6 inline-flex rounded-full border border-[#899B6A] px-5 py-3 text-sm font-medium text-[#2C3618] transition-[border-color,background-color,transform] duration-300 hover:-translate-y-[1px] hover:border-[#4A5D23] hover:bg-[#D5D8CB]/35"
                >
                    Download the app to vote.
                </a>
                <p className="mt-6 text-xs text-[#5C5F58]">
                    Places are added by the community — venues aren’t affiliated with or endorsing
                    Lunar.
                </p>
            </Reveal>
        </section>
    );
};
